var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Graduatioin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-graduatioin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7274",
    "data-name": "Rectangle 7274",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M9.391,3.448a3.353,3.353,0,0,1,3.339,0L20.841,8.1a.559.559,0,0,1,0,.969l-3.073,1.764v5.017a.559.559,0,0,1-.164.4l0,0,0,0-.008.007-.025.024-.09.082c-.077.069-.19.164-.336.277a9.059,9.059,0,0,1-1.276.82,10.342,10.342,0,0,1-9.608,0,9.054,9.054,0,0,1-1.276-.82c-.146-.113-.258-.209-.336-.277l-.09-.082a.594.594,0,0,1-.2-.431V10.838L2.118,9.555v5.183a.559.559,0,0,1-1.118,0V8.589A.559.559,0,0,1,1.291,8.1ZM12.73,13.73a3.353,3.353,0,0,1-3.339,0L5.471,11.48v4.126c.052.044.117.1.194.156a7.947,7.947,0,0,0,1.117.717,9.225,9.225,0,0,0,8.556,0,7.943,7.943,0,0,0,1.117-.717c.077-.059.141-.112.194-.156V11.48Zm-.557-9.312a2.236,2.236,0,0,0-2.226,0L2.681,8.589l7.266,4.171a2.236,2.236,0,0,0,2.226,0L19.44,8.589Z",
    transform: "translate(0.939 1.174)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Graduatioin);
export default __webpack_public_path__ + "static/media/icon-24-graduatioin.0d8711dcaa97291dde87bdd3eab74838.svg";
export { ForwardRef as ReactComponent };